import { Card } from "../ui/card";
import { Button } from "../ui/button";

interface StoriesErrorStateProps {
    onRetry: () => void;
}

export function StoriesErrorState({ onRetry }: StoriesErrorStateProps) {
    return (
        <Card className="p-8 border-destructive/20 bg-destructive/5">
            <div className="text-center text-destructive">
                <p>Failed to load stories</p>
                <Button
                    variant="outline"
                    size="sm"
                    className="mt-2 hover:text-primary hover:border-primary"
                    onClick={onRetry}
                >
                    Try Again
                </Button>
            </div>
        </Card>
    );
}
